export const getIsMenuVisible = state => state.isMenuVisible;
export const getIsAgendaSectionOpen = state => state.isAgendaSectionOpen;
export const getIsAfpAgendaSectionOpen = state => state.isAfpAgendaSectionOpen;
